// BuildProject360 brand marks — code-based SVG so they stay sharp at any size.

export function LogoIcon({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" className={className} role="img" aria-label="BuildProject360" data-testid="logo-icon">
      <rect width="48" height="48" rx="12" fill="#071A33" />
      <path d="M 40.2 17.4 A 17.5 17.5 0 1 0 41 27" fill="none" stroke="#29C5F6" strokeWidth="2.6" strokeLinecap="round" />
      <text x="24" y="29.5" textAnchor="middle" fontFamily="Manrope, system-ui, sans-serif" fontWeight="800" fontSize="15.5" fill="#FFFFFF">360</text>
    </svg>
  );
}

// Approved vector wordmark (no tagline — unreadable at nav size).
// Sized via className height; width stays proportional.
export function LogoWordmark({ dark = false, className = "h-6", testid = "logo-wordmark" }) {
  return (
    <svg viewBox="0 0 500 64" className={`w-auto ${className}`} role="img" aria-label="BuildProject360" data-testid={testid} preserveAspectRatio="xMinYMid meet">
      <text x="0" y="50" fontFamily="Manrope, system-ui, sans-serif" fontWeight="800" fontSize="50" letterSpacing="-1">
        <tspan fill={dark ? "#FFFFFF" : "#0F2440"}>BuildProject</tspan><tspan fill="#29C5F6">360</tspan><tspan fontSize="18" dy="-26" fill={dark ? "#94A3B8" : "#64748B"}>™</tspan>
      </text>
    </svg>
  );
}
